@if (bigScreenMode) {
  <ion-menu
    menuId="asset-sidepane-menu"
    contentId="asset-content"
    [ngClass]="className$ | async"
    type="overlay"
    (ionDidClose)="resetMenu()"
  >
    @if (showSpinner) {
      <ion-spinner [color]="spinnerColor$ | async"></ion-spinner>
    } @else {
      <sis-asset-sidepane-content [showQrCode]="showQrCode"></sis-asset-sidepane-content>
    }
  </ion-menu>
}
